module.exports = __webpack_public_path__ + "img/橋藝.d150354f.jpg";